import './HeaderGenericTertiary.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM } from '../../utils';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
const HeaderGenericTertiary = _ref => {
  let {
    fields,
    params
  } = _ref;
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const pageTitle = get(fields, 'data.item.pageTitle') || get(fields, 'pageTitle');
  const pageTitleValue = get(fields, 'pageTitle.value') || get(fields, 'data.item.pageTitle.value');
  const pageIntro = get(fields, 'pageIntro') || get(fields, 'data.item.pageIntro.value');
  const [state, setstate] = React.useState('');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const GradientColor = get(params, 'GradientColorHex');
  let gradient = null;
  if (BackgroundColorHex && BackgroundColorHex.length && GradientColor && GradientColor.length) {
    gradient = "h1put96c";
  }
  const variables = BackgroundColorHex ? {
    "--m57-Generic-Tertiary-title-color": ColorHex,
    "--m57-Generic-Tertiary-intro-color": ColorHex,
    "--m57-Generic-Tertiary-background-color": BackgroundColorHex
  } : {
    "--m57-Generic-Tertiary-title-color": '#000',
    "--m57-Generic-Tertiary-intro-color": '#40484F',
    "--m57-Generic-Tertiary-background-color": "linear-gradient(180deg, #fff 0%, #DDE2EB 100%)"
  };
  React.useEffect(() => {
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) setstate(`#${decodeURI(hashvalue[1])}`);
    }
  }, []);
  if (!fields) {
    console.warn('HeaderGenericTertiary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericTertiary component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isSharedCh: isSharedCh,
    style: {
      '--startColor': BackgroundColorHex,
      '--endColor': GradientColor
    },
    className: GradientColor && gradient && GradientColor.length ? gradient : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: `module-group ${isSharedCh ? "" : "no-padding-bottom"}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: isSharedCh ? 'header-generic--wrapper col-xl-12' : 'col-xl-11'
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageEditing && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: pageTitle,
    className: "h2 c-title__text"
  }), !pageEditing && /*#__PURE__*/React.createElement("h1", {
    className: "h2 c-title__text"
  }, `${pageTitleValue} ${state}`), isSharedCh && pageIntro && /*#__PURE__*/React.createElement("div", {
    className: "p header__content",
    dangerouslySetInnerHTML: {
      __html: pageIntro
    }
  }))))), !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageIntro && /*#__PURE__*/React.createElement("div", {
    className: "p header__content",
    dangerouslySetInnerHTML: {
      __html: pageIntro
    }
  })))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    className,
    isSharedCh,
    style
  } = _ref2;
  const commonStyles = isSharedCh ? "cps6bsb" : "ce1b3ee";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${className} ${headerImageStyle}`
  }, children);
};
export default HeaderGenericTertiary;